// Database service export for the application
// This file provides a unified interface for database operations

import { apiClient } from './api-client';
import companyParameterService from '../services/companyParameterService';

// API-backed database service (no browser DB)
export const dbService: any = {} as any;

// Site info and content
dbService.getAboutInfo = async () => {
  const res = await apiClient.getAboutInfo();
  return (res as any)?.about ?? res;
};
dbService.saveAboutInfo = async (about: any) => {
  const res = await apiClient.updateAboutInfo(about);
  return (res as any)?.about ?? res;
};
dbService.getTeamMembers = async () => {
  const res = await apiClient.getTeamMembers();
  return (res as any)?.members ?? res;
};
dbService.saveTeamMembers = async (members: any[]) => {
  const res = await apiClient.saveTeamMembers(members);
  return (res as any)?.members ?? res;
};
dbService.getBlogs = async (params: any = {}) => {
  const res = await apiClient.getBlogs(params);
  return (res as any)?.blogs ?? res;
};
dbService.saveBlogs = async (blogs: any[]) => {
  const res = await apiClient.saveBlogs(blogs);
  return (res as any)?.blogs ?? res;
};
dbService.getNews = async (params: any = {}) => {
  const res = await apiClient.getNews(params);
  return (res as any)?.news ?? res;
};
dbService.saveNews = async (news: any[]) => {
  const res = await apiClient.saveNews(news);
  return (res as any)?.news ?? res;
};

// Core lists used by dashboards
dbService.getUsers = async (params: any = {}) => {
  const res = await apiClient.getAllUsers({ page: 1, limit: params?.limit ?? 1000, search: params?.search });
  return Array.isArray((res as any)?.users) ? (res as any).users : (Array.isArray(res) ? (res as any) : []);
};
dbService.getJobs = async (filter: any = {}, limit = 1000, skip = 0) => {
  const page = Math.floor(skip / limit) + 1;
  const res = await apiClient.getJobs({ page, limit, status: filter?.status ?? 'active', category: filter?.category_id, location: filter?.location });
  return Array.isArray((res as any)?.jobs) ? (res as any).jobs : (Array.isArray(res) ? (res as any) : []);
};
dbService.getCompanies = async (params: any = {}) => {
  const res = await apiClient.getCompanies({ page: 1, limit: params?.limit ?? 1000, industry: params?.industry, search: params?.search });
  return Array.isArray((res as any)?.companies) ? (res as any).companies : (Array.isArray(res) ? (res as any) : []);
};
dbService.getApplications = async (filter: any = {}) => {
  const res = await apiClient.getAdminApplications({ page: 1, limit: 1000, status: filter?.status ?? 'all', jobId: filter?.job_id || filter?.jobId });
  return Array.isArray((res as any)?.applications) ? (res as any).applications : (Array.isArray(res) ? (res as any) : []);
};
dbService.getJobCategories = async () => {
  try {
    const res: any = await companyParameterService.list('job_category');
    return Array.isArray(res?.items) ? res.items : (Array.isArray(res) ? res : []);
  } catch {
    return [];
  }
};
dbService.saveCompanies = async (companies: any[]) => {
  try {
    const res = await apiClient.saveSectionSettings('trusted_companies', { companies }, true);
    return (res as any)?.config?.companies ?? companies;
  } catch {
    return companies;
  }
};

// Legacy no-op used by diagnostics to clear seeds
dbService.setupDatabase = async () => {
  try {
    localStorage.removeItem('mysql_megajob_db_users');
    localStorage.removeItem('mysql_megajob_db_jobs');
    localStorage.removeItem('mysql_megajob_db_companies');
    sessionStorage.removeItem('mysql_megajob_db_users');
  } catch {}
  return { ok: true };
};

// Re-export types for convenience
export type { User, Company, Job, JobCategory, Application } from './postgresql-types';
